import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-faultlog",
  "use": "icon-soc-m-faultlog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-faultlog\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"780\" cy=\"180\" r=\"28\" /><circle cx=\"512\" cy=\"512\" r=\"320\" /><path d=\"M320 320l384 384M704 320L320 704\" stroke=\"#fff\" stroke-width=\"64\" fill=\"none\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-faultlog.svg
// module id = +O1Y
// module chunks = 477